import React from "react";
import { Col, Row } from "react-bootstrap";

const ExecutarOrdemServicoDetalhes = ({ data }) => {
  let mostrarNumAuto = false;

  if (
    data.descTipoAcaoFiscal === "AUDITORIA" ||
    data.descTipoAcaoFiscal === "AUDITORIA ESPECÍFICA" ||
    data.descTipoAcaoFiscal === "AUDITORIA DE BAIXA DE INSCRIÇÃO ESTADUAL" ||
    data.descTipoAcaoFiscal === "DILIGÊNCIA"
  ) {
    mostrarNumAuto = true;
  }

  return (
    <div style={{ width: "100%" }}>
      <Row style={{ margin: 20, textAlign: "left" }}>
        <Col sm="1">
          <strong>Setor: </strong>
          <br />
          <span>{data.siglaOrgao}</span>
        </Col>
        <Col sm="4">
          <strong>Executores: </strong>
          <br />
          <ul>
            {data.executores.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </Col>
        <Col sm="3">
          <strong>Fase: </strong>
          <br />
          <span>{data.nmFase ?? "-"}</span>
        </Col>
        <Col sm="2">
          <strong>Status: </strong>
          <br />
          <span>{data.status ?? "-"}</span>
        </Col>
        <Col sm="2">
          <strong>{mostrarNumAuto ? "Nº dos Autos:" : ""} </strong>
          <br />
          {mostrarNumAuto
            ? (
                <ul>
                  {data.produtosAcaoFiscal.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              ) ?? "-"
            : ""}
        </Col>
      </Row>
    </div>
  );
};

export default ExecutarOrdemServicoDetalhes;
